import { render } from "./TechWorksPlaceholder.vue?vue&type=template&id=1226f833&scoped=true&ts=true"
import script from "./TechWorksPlaceholder.vue?vue&type=script&lang=ts"
export * from "./TechWorksPlaceholder.vue?vue&type=script&lang=ts"

import "./TechWorksPlaceholder.vue?vue&type=style&index=0&id=1226f833&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1226f833"]])

export default __exports__